import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { getNotifications } from '../../redux/notifications/notifications.actions';
import NotificationCard from './notificationCard';

const Notifications = ({ getNotifications, notificationList }) => {
	useEffect(() => {
		getNotifications();
	}, [getNotifications]);

	let unreadNotification =
		!!notificationList &&
		Object.keys(notificationList).length > 0 &&
		Object.keys(notificationList).filter((x) => notificationList[x].unread === 1);

	const handleNotifyClose = (e) => {
		const key = e.target.getAttribute('data-id');
		document.getElementById(`carousel_${key}`).remove();
		document.getElementById(`notifyCard_${key}`).remove();

		const nextkey =
			Object.entries(unreadNotification).length - 1 > key ? parseInt(key) + 1 : 0;
		document.getElementById(`carousel_${nextkey}`).classList.add('active');
		document.getElementById(`notifyCard_${nextkey}`).classList.add('active');
	};

	let NotificationData = Object.keys(unreadNotification).map((key) => {
		let active = key === '0' ? 'active' : '';
		return (
			<NotificationCard
				handleNotifyClose={handleNotifyClose}
				status={active}
				index={key}
				{...notificationList[key]}
			/>
		);
	});

	return (
		<div
			id="myCarousel"
			className="carousel slide NotifyCarousel"
			data-ride="carousel"
		>
			<div className="carousel-inner">{NotificationData}</div>
			<ol className="carousel-indicators">
				{Object.keys(unreadNotification).map((key) => {
					let active = key === '0' ? 'active' : '';
					return (
						<li
							data-target="#myCarousel"
							id={`carousel_${key}`}
							data-slide-to={`${key}`}
							className={`${active} carouselRoll`}
						></li>
					);
				})}
			</ol>
		</div>
	);
};

const mapStateToProps = (state) => {
	const { notificationList } = state.rootReducer.notifications;
	return {
		notificationList,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		getNotifications: () => dispatch(getNotifications()),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(Notifications);
